import React from 'react';
import { IProps, IFlowItems } from 'components/Home/FlowRemind/Flow/types';
import SliderMobile from 'components/SliderMobile';

const Flow: React.FC<IProps> = (props) => {
  /**
     * @description 分割投保流程標題文字與數字
     * @param str 投保流程標題
     */
  const flowTitleFormat = (str: string) => {
    if (!str) return;
    // 取得內容第一個數字 index
    let numIndex = 0;
    for (let i = 0; i < str.length; i += 1) {
      if (!isNaN(+str[i])) {
        numIndex = i;
        break;
      }
    }
    // 利用數字 index 分割內容顯示
    return (
      <>
        <span>{str.substring(0, numIndex)}</span>
        <span>{`0${str.substring(numIndex)}`}</span>
      </>
    );
  };

  /**
   * @description 格式化投保流程文字
   * @param str 文字內容
   * @param index 文字位置
  */
  const flowTextFormat = (str: string, subIndex?: number) => {
    if (subIndex !== undefined && subIndex === 0) return <p>{str}</p>;

    if (str.indexOf('(') !== -1 && !subIndex) {
      const strArray = str.split('(');

      return (
        <>
          <p>{strArray[0]}</p>
          <p>{`(${strArray[1]}`}</p>
        </>
      );
    }

    if (subIndex) {
      const strFront = str.substring(0, subIndex);
      const strBack = str.substring(subIndex);
      return (
        <>
          <p>{strFront}</p>
          <p>{`${strBack}`}</p>
        </>
      );
    }

    return <p>{str}</p>;
  };

  return (
    <>
      <div className="flow-remind__flow">
        {props.items && props.items.map((flow: IFlowItems, index: number) => (
          <div className={`flow-remind__flow-item flow-remind__flow-item--${index + 1}`} key={index}>
            <div className="flow-remind__flow-item-icon" style={props.itemIconStyles && index === 0 ? props.itemIconStyles : {}}>
              <img src={flow.icon} alt={flow.text} />
            </div>
            <div className="flow-remind__flow-item-title">
              {flow.title && flowTitleFormat(flow.title)}
            </div>
            <div className="flow-remind__flow-item-desc">{flow.title2}</div>
            <div className="flow-remind__flow-item-desc">
              {
                flowTextFormat(flow.text, flow.subTextIndex)
              }
            </div>
            <div className="flow-remind__flow-item-desc2">{flow.desc}</div>
          </div>
        ))}
      </div>
      <div className="flow-remind-mobile__flow">
        <SliderMobile
          name={props.name}
          config={props.sliderMobileConfig}
        >
          {props.items && props.items.map((flow: IFlowItems, index: number) => (
            <SliderMobile.Item key={index}>
              <div className={`flow-remind__flow-item flow-remind__flow-item--${index + 1}`}>
                <div className="flow-remind__flow-item-icon">
                  <img src={flow.icon} alt={flow.text} />
                </div>
                <div className="flow-remind__flow-item-title">
                  {flow.title && flowTitleFormat(flow.title)}
                </div>
                <div className="flow-remind__flow-item-desc">{flow.title2}</div>
                <div className="flow-remind__flow-item-desc">
                  {
                    flowTextFormat(flow.text, flow.subTextIndex)
                  }
                </div>
                <div className="flow-remind__flow-item-desc2">{flow.desc}</div>
              </div>
            </SliderMobile.Item>
          ))}
        </SliderMobile>
      </div>
    </>
  );
};

Flow.defaultProps = {
  name: 'flow-mobile-items-slider'
};

export default Flow;
